export { EloItalicIcon } from './italic-icon'
